// mui
import { makeStyles } from '@material-ui/core/styles'

// third party libraries
import { Reorder, useDragControls } from 'framer-motion'

// custom components
import { Text } from '../../../1elements'
import FormTextField from '../../../2compounds/FormTextField'
import DragIconButton from '../../../1elements/Buttons/IconButtons/DragIconButton'
import ShowHideButton from '../../../1elements/Buttons/IconButtons/ShowHideButton'
import DataTypeDropDown from '../../../2compounds/Select/DataTypeDropDown'

const MultipleColumnsDataListAdmin = ({
  data,
  cardIndex,
  fieldIndex,
  updateFieldLabel,
  toggleIsHidden,
  numberOfColumn,
  updateDataType
}) => {
  const classes = useStyles({ numberOfColumn })
  const { label, type, isHidden, isMandatory } = data
  const controls = useDragControls()

  return (
    <Reorder.Item
      value={data}
      dragListener={false}
      dragControls={controls}
      className={`${classes.root} ${isHidden && classes.reorderInnerDivHidden}`}
    >
      <div className={classes.fieldLabelDiv}>
        <DragIconButton sscontrols={controls} />
        <ShowHideButton
          show={!isHidden}
          toggleIsHidden={() => toggleIsHidden(cardIndex, fieldIndex)}
          className={classes.showHideButton}
        />
        <FormTextField
          value={label}
          onChange={newValue =>
            updateFieldLabel(cardIndex, fieldIndex, newValue)
          }
          className={classes.textField}
        />
      </div>

      {isMandatory ? (
        <Text className={classes.data}>{type}</Text>
      ) : (
        <DataTypeDropDown
          value={type}
          onChange={newValue => updateDataType(cardIndex, fieldIndex, newValue)}
          className={classes.data}
        />
      )}
    </Reorder.Item>
  )
}

export default MultipleColumnsDataListAdmin

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    width: '100%',
    margin: '5px 0',
    gridTemplateColumns: props => `repeat(${props.numberOfColumn}, 1fr)`
  },
  textField: {
    width: 250,

    '& .MuiInputBase-input': {
      padding: '1px 3px'
    }
  },
  fieldLabelDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  reorderInnerDivHidden: {
    opacity: 0.6,
    '&>*': {
      boxShadow: 'none'
    }
  },
  data: {
    gridColumn: '-2/-1',
    maxWidth: 110,
    height: 23,
    justifySelf: 'end',
    '& .MuiSelect-select': {
      height: 22
    }
  },
  showHideButton: {
    margin: '0 5px'
  }
}))
